import { useTranslation } from "react-i18next";
import { NavBar } from "../../components/navBar";
import Footer from "../../components/Footer";

export const NotLogged = () => {
    const { t } = useTranslation();
    return (  <div className="min-h-screen flex flex-col">
        <NavBar />
        <main className="flex-grow pt-[70px] px-6 py-12">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-white mb-6">
              {t("pages.profile.title", "Profilo")}
            </h1>
            <p className="text-white text-lg">
              {t(
                "pages.profile.loginRequired",
                "Devi effettuare il login per visualizzare il tuo profilo."
              )}
            </p>
          </div>
        </main>
        <Footer />
      </div>);
}